const NotFoundPost = () => {
  return (
    <div className="w-full text-center">
      <h1 className="py-8 px-4">Post not found</h1>
    </div>
  );
};

export default NotFoundPost;
